<!--
    描述：菜单接口管理页面
    时间：2020-04-30
    Created by yefan
-->
<template>
    <div class="h100">
        <w-split class="h100" v-model="splitValue">
            <div class="w-page-main left" slot="left">
                <div class="w-page-header">
                    <div class="left-text overflow-hidden">
                        <span>
                            <b>系统菜单</b>
                        </span>
                    </div>
                </div>
                <div class="w-page-container pdb10">
                    <menuTreeTable @row-click="rowClick" ref="menuTreeTable"></menuTreeTable>
                </div>
            </div>
            <div class="w-page-main right" slot="right">
                <div class="w-page-header">
                    <div class="left-text overflow-hidden">
                        <span>
                            <b>菜单接口</b>
                        </span>
                    </div>
                    <search-area ref="searchContent" v-model="searchForm.name" :showMore="false" placeholderName="接口功能"
                                 @on-search="onSearch" @on-refresh="onRefresh" @on-reset="onReset">
                    </search-area>
                </div>
                <div class="w-page-container pdb10">
                    <interfaceTreeTable ref="interfaceTreeTable"></interfaceTreeTable>
                </div>
            </div>
        </w-split>
    </div>
</template>
<script>
    import wSplit from '@/components/split/split'
    import searchArea from '../../../components/searchArea/searchArea'
    import menuTreeTable from './components/menu_tree_table'
    import interfaceTreeTable from './components/interface_tree_table'

    export default {
        components: {wSplit, menuTreeTable, interfaceTreeTable, searchArea},
        data() {
            return {
                splitValue: 0.25,
                deptId: '',
                searchForm: {
                    name: '',
                    menuId:''
                },
                menuId:''
            }
        },
        methods: {
            //单击左侧菜单列表行事件
            rowClick(obj) {
                this.searchForm.menuId = obj.id;
                this.$refs.interfaceTreeTable.getMenuTreeTableData(this.searchForm);
            },

            // 确认搜索
            onSearch() {
                this.$refs.interfaceTreeTable.getMenuTreeTableData(this.searchForm);
            },

            // 点击刷新
            onRefresh() {
                this.onReset();
                this.onSearch()
            },

            // 点击重置
            onReset() {
                this.searchForm.name = ''
            },
        },
        // 进入缓存页面
        activated() {
            this.splitValue = 0.25
        }
    }
</script>
<style scoped lang="less"></style>
